import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class PrivateStockType extends Enum {
  static ISO = {
    key: 'ISO',
    get value() {
      return Lang.t('asset.incentive-stock-options');
    }
  };

  static LTCG = {
    key: 'LTCG',
    get value() {
      return Lang.t('asset.long-capital-gains');
    }
  };

  static NSO = {
    key: 'NSO',
    get value() {
      return Lang.t('asset.non-stock-option');
    }
  };

  static QSBS = {
    key: 'QSBS',
    get value() {
      return Lang.t('asset.qualified-small-stock');
    }
  };

  static RSU = {
    key: 'RSU',
    get value() {
      return Lang.t('asset.restricted-stock-units');
    }
  };
}
